export type { SectionProps } from './Section';
export { default } from './Section';
